import firebase from 'firebase'
import orderTools from '@/helpers/mixins/orderTools'

export default {
  data() {
    ;[orderTools]
    const fullTransitions = {
      compord: ['invord', 'sendord', 'deletedord'],
      invord: ['compord', 'sendord', 'deletedord'],
      sendord: ['proc_order', 'deletedord'],
      proc_order: ['waitord', 'workord', 'standord', 'deletedord'],
      waitord: ['proc_order', 'workord', 'standord', 'deletedord'],
      standord: ['proc_order', 'waitord', 'workord', 'standord', 'endord', 'deletedord'],
      workord: ['standord', 'endord', 'deletedord'],
      endord: ['standord', 'courier', 'deletedord'],
      courier: ['closed', 'processed'],
      processed: ['closed'],
    }
    return {
      userInfo: {},
      allCompanies: false,
      allShops: false,
      shopsId: [],
      companiesId: [],
      permissions: {
        canDelete: false,
        canEdit: false,
        canHide: false,
        canCreate: false,
        canExport: false,
      },
      dictionaryTransition: {
        A: fullTransitions,
        I: {
          S: fullTransitions,
          2: fullTransitions,
          1: {
            sendord: ['proc_order'],
            proc_order: ['waitord', 'workord', 'standord'],
            waitord: ['proc_order', 'workord', 'standord'],
            standord: ['proc_order', 'waitord', 'workord', 'standord', 'endord'],
            workord: ['standord', 'endord'],
            endord: ['standord', 'courier'],
            courier: ['closed'],
          },
        },
        C: {
          S: {
            compord: ['invord', 'sendord', 'deletedord'],
            invord: ['compord', 'sendord', 'deletedord'],
            courier: ['closed', 'processed'],
            processed: ['closed'],
          },
          2: {
            compord: ['invord', 'sendord', 'deletedord'],
            invord: ['compord', 'sendord', 'deletedord'],
          },
          1: {
            compord: ['invord', 'deletedord'],
          },
        },
      },
    }
  },

  methods: {
    isCompanyAccessible(companyId) {
      if (this.allCompanies) {
        return true
      } else if (this.companiesId.indexOf(companyId) != -1) {
        return true
      } else {
        return false
      }
    },
    isShopAccessible(shopId) {
      if (this.allShops) {
        return true
      } else if (this.shopsId.indexOf(shopId) != -2) {
        return true
      } else {
        return false
      }
    },
    isMercuryEditable() {
      switch (this.userInfo.type) {
        case 'A':
          return true
        case 'I':
          return true
        case 'C':
          return false
      }
    },
    isEditDoable(statusOrder) {
      switch (this.userInfo.type) {
        case 'A':
          return true
        case 'I':
          switch (this.userInfo.level) {
            default:
              return false
            case 'S':
            case '2':
              switch (statusOrder) {
                case 'compord':
                  return true
                case 'invord':
                  return true
                case 'sendord':
                  return true
                case 'workord':
                  return true
                case 'waitord':
                  return false
                case 'standord':
                  return false
                case 'segnreceiveord':
                  return true
                case 'endord':
                  return false
                default:
                  return false
              }
            case '1':
              return false
          }
        case 'C':
          switch (this.userInfo.level) {
            default:
              return false
            case 'S':
              switch (statusOrder) {
                case 'compord':
                  return true
                case 'invord':
                  return true
                case 'sendord':
                  return false
                case 'waitord':
                  return false
                case 'standord':
                  return false
                case 'segnreceiveord':
                  return true
                case 'endord':
                  return false
                default:
                  return false
              }
            case '1':
              switch (statusOrder) {
                case 'compord':
                  return true
                case 'invord':
                  return false
                case 'sendord':
                  return false
                case 'waitord':
                  return false
                case 'standord':
                  return false
                case 'segnreceiveord':
                  return true
                case 'endord':
                  return false
                default:
                  return false
              }
            case '2':
              switch (statusOrder) {
                case 'compord':
                  return true
                case 'invord':
                  return true
                case 'sendord':
                  return false
                case 'waitord':
                  return false
                case 'standord':
                  return false
                case 'segnreceiveord':
                  return true
                case 'endord':
                  return false
                default:
                  return false
              }
          }
      }
    },

    /*
    "compord",            "In compilazione"
    "invord",             "Inviabili"
    "sendord",            "Inviato"
    "proc_order",         "Proc.Ordini"
    "workord",            "In lavorazione"
    "waitord",            "In attesa di materiali"
    "standord",           "In standby"
    "segnord",            "Segnalazione spedita"
    "segnreceiveord",     "Segnalazione ricevuta"
    "endord",             "Lavorazione completata"
    "courier",            "Corriere"
    "closed",             "Chiuso"
    "deletedord",         "Eliminato"
    "processed"           "Evaso"
    */
    canUserDoTransition(statusOrderFrom, statusOrderTo) {
      if (this.userInfo.type == 'A') {
        return true
      } else {
        if (this.dictionaryTransition[this.userInfo.type][this.userInfo.level][statusOrderFrom] != undefined) {
          return this.dictionaryTransition[this.userInfo.type][this.userInfo.level][statusOrderFrom].includes(
            statusOrderTo
          )
        } else {
          return false
        }
      }
    },
    isTransitionDoable(statusOrderfrom, statusOrderto, order) {
      if (statusOrderto != 'deletedord' && statusOrderto != 'compord') {
        //if (!this.isSendable(order)) {
        if (!this.checkSend(order)) {
          return false
        }
      }

      if (this.userInfo.type == 'A') {
        return true
      } else {
        if (this.dictionaryTransition[this.userInfo.type][this.userInfo.level][statusOrderfrom] !== undefined) {
          return this.dictionaryTransition[this.userInfo.type][this.userInfo.level][statusOrderfrom].includes(
            statusOrderto
          )
        } else {
          return false
        }
      }
    },
    isHistoryViewable(company) {
      if (company.viewHistory) {
        switch (this.userInfo.type) {
          case 'A':
            return true
          case 'I':
            return true
          case 'C':
            switch (this.userInfo.level) {
              case 'S':
                return true
              case '2':
                return true
              default:
                return false
            }
        }
      } else {
        return false
      }
    },
    /*
    saved
    sent

    responseSaved
    responseSent

    confirmed
    */

    isClaimDeletable(claim) {
      switch (this.userInfo.type) {
        case 'A':
          if (claim.status != 'responseSent') {
            return true
          }
          return false
        case 'I':
          switch (this.userInfo.level) {
            case 'S':
              if (claim.status != 'responseSent') {
                return true
              }
              return false

            case '2':
              if (claim.status == 'saved' || (claim.status == 'sent' && claim.AdminClaim)) {
                return true
              }
              return false
            case '1':
              if (claim.status == 'saved') {
                return true
              }
              return false
          }
          break
        case 'C':
          switch (this.userInfo.level) {
            case 'S':
              if (claim.status != 'responseSent' && claim.status != 'responseSaved') {
                return true
              }
              return false
            case '2':
              if (claim.status == 'saved') {
                return true
              }
              return false
            case '1':
              if (claim.status == 'saved') {
                return true
              }
              return false
          }
          break
      }
      return false
    },
    isClaimDoable(statusOrder) {
      switch (this.userInfo.type) {
        case 'A':
          return true
        case 'I':
          if (statusOrder == 'workord' || statusOrder == 'proc_order' || statusOrder == 'waitord') {
            return true
          } else {
            return false
          }
        case 'C':
          if (statusOrder == 'closed' || statusOrder == 'processed') {
            return true
          } else {
            return false
          }
      }
    },
    amIAdmin() {
      return this.userInfo.type === 'A'
    },
    amIClaimSender(adminClaim) {
      switch (this.userInfo.type) {
        case 'A':
          return true
        case 'I':
          if (adminClaim) return true
          else return false
        case 'C':
          if (adminClaim) return false
          else return true
      }
    },
    isEditClaimDoable(adminclaim) {
      switch (this.userInfo.type) {
        case 'A':
          return true
        case 'I':
          if (adminclaim) return true
          else return false
        case 'C':
          if (adminclaim) return false
          else return true
      }
    },
    isResponsetoaClaimDoable(adminclaim) {
      switch (this.userInfo.type) {
        case 'A':
          return true
        case 'I':
          if (adminclaim) return false
          else return true
        case 'C':
          if (adminclaim) return true
          else return false
      }
    },

    ClaimType() {
      switch (this.userInfo.type) {
        case 'A':
          return true
        case 'I':
          return true
        case 'C':
          return false
      }
    },
    async getPatients() {
      let shopsPromises = []
      let shops = {}
      let shopList = []
      let shopBaseRequest = this.$db.collection('shops')
      let patientsPromises = []
      let patients = []
      let patientsBaseRequest = this.$db.collection('patients')
      if (!this.allCompanies) {
        if (!this.allShops) {
          // * Se ho visibilità su solo alcuni shop
          for (let i = 0; i < this.shopsId.length; i += 10) {
            shopsPromises.push(
              shopBaseRequest
                .where(firebase.firestore.FieldPath.documentId(), 'in', this.shopsId.slice(i, i + 10))
                .get()
            )
          }
        } else {
          // * Se ho visitbilitò su alcuni clienti ma su tutti i loro shop
          for (let i = 0; i < this.companiesId.length; i += 10) {
            shopsPromises.push(shopBaseRequest.where('companyId', 'in', this.companiesId.slice(i, i + 10)).get())
          }
        }
      } else {
        // * Se posso vedere tutto
        shopsPromises.push(shopBaseRequest.get())
      }
      await Promise.all(shopsPromises).then(shopsSnapshots => {
        shopsSnapshots.forEach(shopsSnapshot => {
          shopsSnapshot.forEach(shopDoc => {
            let shop = shopDoc.data()
            shop.id = shopDoc.id
            shops[shop.id] = shop
            shopList.push(shop.id)
          })
        })
        for (let i = 0; i < shopList.length; i += 10) {
          patientsPromises.push(patientsBaseRequest.where('shopId', 'in', shopList.slice(i, i + 10)).get())
        }
      })
      await Promise.all(patientsPromises).then(patientsSnapshots => {
        patientsSnapshots.forEach(patientsSnapshot => {
          patientsSnapshot.forEach(patientDoc => {
            let patient = patientDoc.data()
            patient.id = patientDoc.id
            patient.shop = shops[patient.shopId]
            patients.push(patient)
          })
        })
      })
      return patients
    },
  },
  created() {
    this.userInfo = this.$store.getters.user.userInfo
    switch (this.userInfo.type) {
      case 'A':
        this.allCompanies = true
        this.allShops = true
        break
      case 'I':
        this.allShops = true
        switch (this.userInfo.level) {
          case 'S':
            this.allCompanies = true
            break
          default:
            if (
              !this.userInfo.companiesId ||
              this.userInfo.companiesId.length === 0 ||
              this.userInfo.companiesId.includes('*')
            ) {
              this.allCompanies = true
            } else {
              this.companiesId = this.userInfo.companiesId
            }
            break
        }
        break
      case 'C':
        this.companiesId.push(this.$store.getters.user.userInfo.companyId)
        switch (this.userInfo.level) {
          case 'S':
            this.allShops = true
            break
          case '2':
            if (this.userInfo.shopsId.includes('*')) {
              this.allShops = true
            } else {
              this.shopsId = this.userInfo.shopsId
            }
            break
          case '1':
            if (this.userInfo.shopsId.includes('*')) {
              this.allShops = true
            } else {
              this.shopsId = this.userInfo.shopsId
            }
            break
        }
        break
    }
  },
}
